import { Mapstyles } from './mapstyles';

function onEachFeature(feature, layer) {
  layer.on('click', this.clickedFeature);
  layer.bindTooltip(this.generateTooltip(feature), { direction: 'top', sticky: true });
  layer.on('mouseover', this.mouseOverRegion);
  layer.on('mouseout', this.mouseOutRegion);
  layer.setStyle(this.calculateStyle(feature.properties.mapInfos, false));
}

function generateTooltip(feature) {
  let warningIcon =
    !feature.properties.mapInfos.otaUpdatePossible && !feature.properties.mapInfos.selectedOTARegion
      ? "<wb-icon class='wb-button__icon warning-icon' aria-hidden='true' name='warning'></wb-icon>" + ' '
      : '';
  let otaRegionDescription = feature.properties.mapInfos.selectedOTARegion
    ? '<div class="wb-type-hint-strong">' + this.$t('overview.otaregion') + '</div>'
    : '';
  return (
    '<div class="wb-type-copy tooltip">' +
    warningIcon +
    feature.properties.mapInfos.regionDescription +
    otaRegionDescription +
    '</div>'
  );
}

function mouseOverRegion(e) {
  let mapRegion = e.target.feature.properties.mapInfos;
  e.target.setStyle(this.calculateStyle(mapRegion, true));
}

function mouseOutRegion(e) {
  let mapRegion = e.target.feature.properties.mapInfos;
  e.target.setStyle(this.calculateStyle(mapRegion, false));
}

function calculateStyle(mapRegion, hovered) {
  let style = {};
  if (mapRegion.upToDate) {
    style = hovered ? Mapstyles.upToDate_Hover : Mapstyles.upToDate;
  } else {
    style = hovered ? Mapstyles.outdated_Hover : Mapstyles.outdated;
  }
  if (this.isOtaRegionStyle(mapRegion)) {
    let otaStyle = hovered ? Mapstyles.otaRegion_Hover : Mapstyles.otaRegion;
    style = Object.assign({}, style, otaStyle);
  } else if (this.isUserSelectedOtaRegionOutdated(mapRegion)) {
    style = Object.assign({}, style, Mapstyles.otaRegion_Clicked);
  } else if (isOtaUpdateNotPossible(mapRegion) && hovered) {
    style = Object.assign({}, style, Mapstyles.otaRegion_Clicked);
  }

  if (!mapRegion.selectedOTARegion) {
    Object.assign(style, Mapstyles.cursor_Click);
  } else {
    Object.assign(style, Mapstyles.cursor_Default);
  }
  return style;
}

function isOtaRegionStyle(mapRegion) {
  return this.regionIsNewSelectedOtaRegion(mapRegion) ? true : this.regionIsOldOtaRegion(mapRegion);
}

function regionIsNewSelectedOtaRegion(mapRegion) {
  return (
    this.$store.state.otaChange.selectedRegion !== undefined &&
    this.$store.state.otaChange.selectedRegion.otaUpdatePossible &&
    this.$store.state.otaChange.selectedRegion.regId === mapRegion.regId
  );
}

function regionIsOldOtaRegion(mapRegion) {
  return (
    (this.$store.state.otaChange.selectedRegion === undefined ||
      !this.$store.state.otaChange.selectedRegion.otaUpdatePossible) &&
    mapRegion.selectedOTARegion
  );
}

function isUserSelectedOtaRegionOutdated(mapRegion) {
  return (
    this.$store.state.otaChange.selectedRegion !== undefined &&
    this.$store.state.otaChange.selectedRegion.regId === mapRegion.regId &&
    !this.$store.state.otaChange.selectedRegion.otaUpdatePossible
  );
}

function isOtaUpdateNotPossible(mapRegion) {
  return !mapRegion.otaUpdatePossible && !mapRegion.selectedOTARegion;
}

function redrawMap() {
  this.mapRegionsWithGeoData = JSON.parse(JSON.stringify(this.mapRegionsWithGeoData));
}

export {
  onEachFeature,
  mouseOverRegion,
  mouseOutRegion,
  redrawMap,
  generateTooltip,
  calculateStyle,
  isOtaRegionStyle,
  regionIsNewSelectedOtaRegion,
  regionIsOldOtaRegion,
  isUserSelectedOtaRegionOutdated,
};
